import React, { Component } from 'react';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

class ProfileDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
    });
  }

  addDefaultSrc = (event) => {
    event.target.src = require('../../../../assets/images/default-avatar.png');
  };

  render() {
    if (this.state.width < 992) {
      return <Mobile addDefaultSrc={ this.addDefaultSrc } />;
    }

    return <Desktop addDefaultSrc={ this.addDefaultSrc } />;
  }
}

export { ProfileDropdown };


